const ContactCard = ({ icon = null, title = "", details = [] }) => {
  return (
    <div className="bg-white shadow-md rounded-xl px-6 py-12 flex flex-col items-center text-center transition-all duration-300 hover:shadow-lg">
      <div className="bg-blue-500 text-white p-4 rounded-full text-2xl">
        {icon}
      </div>
      <div className="mt-4 space-y-1">
        {details.map((detail, index) => (
          <p key={index} className="text-gray-800 font-medium">
            {detail}
          </p>
        ))}
      </div>
    </div>
  );
};

export default ContactCard